import { useState } from 'react';
import { ProgressBar } from 'react-aria-components';
import { AgButton } from 'src/components/ui';
import { AgButtonProps } from 'src/components/ui/AgButton';
import { cn } from 'src/components/ui/utils';

export type LoadingButtonProps = {
  handleRequest: () => Promise<unknown>;
  handleRequestComplete?: () => void;
  validateRequest?: () => boolean;
  forceRequesting?: boolean;
  children: React.ReactNode;
} & AgButtonProps;

export default function LoadingButton({
  handleRequest,
  isDisabled,
  handleRequestComplete,
  validateRequest,
  forceRequesting,
  shape = 'rounded',
  className,
  onClick,
  children,
  ...buttonProps
}: LoadingButtonProps) {
  const [isRequesting, setIsRequesting] = useState(false);

  return (
    <AgButton
      variant="primary"
      shape={shape}
      className={cn('relative overflow-hidden', className)}
      onClick={(e) => {
        const isRequestValid = validateRequest?.() ?? true;

        if (!isRequesting && isRequestValid) {
          setIsRequesting(true);
          handleRequest().finally(() => {
            setIsRequesting(false);
            handleRequestComplete?.();
          });
        }

        onClick?.(e);
      }}
      isDisabled={isRequesting || isDisabled}
      {...buttonProps}
    >
      {children}
      <ProgressBar
        aria-label="Loading"
        isIndeterminate
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: forceRequesting || isRequesting ? 3 : 0,
          transition: 'height 0.3s ease-in-out',
          overflow: 'hidden',
        }}
      >
        <div className="h-full w-1/2 animate-indeterminate bg-brand-10 rounded-lg" />
      </ProgressBar>
    </AgButton>
  );
}
